import { Table } from '@/styles/common';
import { Fragment, useRef } from 'react';

type TRenderRow<T> = {
	row: T;
	fieldName: keyof T;
	rowIndex: number;
	colIndex: number;
	onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
	onDragOver: (e: React.DragEvent<HTMLTableDataCellElement>) => void;
	rowHeader?: string;
};

interface EditDataTableProps<T extends Record<string | number, TValue>> {
	rowsData: T[];
	headers: string[];
	actions?: ((row: T, index: number) => JSX.Element | false)[];
	firstCol?: string[];
	renderRow: ({
		row,
		fieldName,
		rowIndex,
		colIndex,
		onFocus,
		onDragOver,
		rowHeader,
	}: TRenderRow<T>) => JSX.Element;
}

const EditDataTable = <T extends Record<string | number, TValue>>({
	rowsData,
	headers,
	actions,
	firstCol,
	renderRow,
}: EditDataTableProps<T>) => {
	const expandRowRef = useRef<HTMLDivElement | null>(null);
	const expandSquareRef = useRef<HTMLSpanElement | null>(null);

	const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
		// if (expandRowRef.current) {
		// 	const parentRect = e.target.parentElement?.getBoundingClientRect()!;
		// 	expandRowRef.current.style.top = `${parentRect.top - 14}px`;
		// 	expandRowRef.current.style.left = `${parentRect.left - 8}px`;
		// 	expandRowRef.current.style.width = `${parentRect.width + 16}px`;
		// 	expandRowRef.current.style.height = `${parentRect.height + 25}px`;
		// 	expandRowRef.current.style.border = '2px solid red';
		// }
	};

	const onDragOver = (e: React.DragEvent<HTMLTableDataCellElement>) => {
		e.preventDefault();

		// const rect = e.currentTarget.getBoundingClientRect();
		// expandRowRef.current!.style.width = `${rect.left - rect.width - 20}px`;
	};

	const row2Tr = (row: T, rowIndex: number) => (
		<tr key={rowIndex}>
			{actions && (
				<td style={{ width: 'fit-content' }}>
					{actions.map((action, rowIndex) => (
						<Fragment key={rowIndex}>{action(row, rowIndex)}</Fragment>
					))}
				</td>
			)}
			{firstCol && (
				<td style={{ width: 'fit-content' }}>
					<span>{firstCol[rowIndex]}</span>
				</td>
			)}
			{Object.keys(row).map((key, colIndex) =>
				renderRow({
					row,
					fieldName: key as keyof T,
					rowIndex,
					colIndex,
					onFocus,
					onDragOver,
					rowHeader: firstCol?.[rowIndex],
				})
			)}
		</tr>
	);

	return (
		<>
			{/* <div
				style={{
					position: 'absolute',
					background: 'transparent',
					zIndex: 999,
					pointerEvents: 'none',
				}}
				ref={expandRowRef}>
				<span
					style={{
						width: '10px',
						height: '10px',
						background: 'blue',
						position: 'absolute',
						bottom: 0,
						right: 0,
						cursor: 'grabbing',
						pointerEvents: 'auto',
					}}
					onDragStart={(e) => {
						e.dataTransfer.setDragImage(
							e.currentTarget,
							window.outerWidth,
							window.outerHeight
						);
					}}
					onDragEnd={(e) => {
						expandRowRef.current!.style.width = '0px';
					}}
					ref={expandSquareRef}
					draggable
				/>
			</div> */}
			<Table hover>
				<thead>
					<tr>
						{firstCol?.length && firstCol.length > 0 && <th></th>}
						{actions && <th></th>}
						{headers.map((header, index) => (
							<th key={index}>{header as string}</th>
						))}
					</tr>
				</thead>
				<tbody>{rowsData.map((row, index) => row2Tr(row as T, index))}</tbody>
			</Table>
		</>
	);
};

export default EditDataTable;
